module.exports = __webpack_public_path__ + "img/aboutcp.006c8049.png";